import React, { useEffect, useState } from 'react';
import { useAuth } from '../../utils/AuthContext';
import { FaAppStore,FaCity, FaBuilding, FaNetworkWired, FaCheckCircle, FaMobileAlt, FaPhone, FaEnvelope, FaUserTie, FaUserCircle, FaRegIdCard } from 'react-icons/fa';

const UserDashboard = () => {
  const { auth } = useAuth();
  const [dateTime, setDateTime] = useState(new Date());
  const [userInfo, setUserInfo] = useState({
    refid: '',
    name: '',
    empcode: '',
    doj: '',
    officePhone: '',
    mobile: '',
    status: '',
    rptOfficer: '',
    designation: '',
    department: '',
    office: '',
    city: '',
    email: '',
    isActive: false,
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Users/${auth.userId}`, {
          headers: {
            'Authorization': `Bearer ${auth.token}`
          }
        });
        if (response.ok) {
          const data = await response.json();
          setUserInfo({
            refid: data.userinfo.refid,
            name: data.userinfo.name,
            empcode: data.userinfo.empcode,
            doj: data.userinfo.doj,
            officePhone: data.userinfo.officePhone,
            mobile: data.userinfo.mobile,
            status: data.userinfo.status,
            rptOfficer: data.userinfo.rpT_officer,
            designation: data.userinfo.designation,
            department: data.userinfo.department,
            office: data.userinfo.office,
            city: data.userinfo.city,
            email: data.userinfo.email,
            isActive: data.userinfo.isActive,
          });
        } else {
          console.error('Failed to fetch user information');
        }
      } catch (error) {
        console.error('Error fetching user information:', error);
      }
    };

    fetchUserInfo();
  }, [auth.userId, auth.token]);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString();
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString();
  };

  return (
    <div className="p-8">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl font-semibold">User Dashboard</h2>
        <div className="text-right">
          <div className="text-lg font-semibold">{formatDate(dateTime)}</div>
          <div className="text-lg font-semibold">{formatTime(dateTime)}</div>
        </div>
      </div>
      <div className="bg-white shadow-md rounded-lg p-6">
        <h3 className="text-xl font-semibold mb-4">User Information</h3>
        <div className="flex flex-wrap">
          <div className="w-1/2 mb-4 flex items-center">
            <FaRegIdCard className="text-2xl mr-2" />
            <p><strong>Ref ID:</strong> {userInfo.refid}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaUserCircle className="text-2xl mr-2" />
            <p><strong>Name:</strong> {userInfo.name}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaUserTie className="text-2xl mr-2" />
            <p><strong>Emp Code:</strong> {userInfo.empcode}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaEnvelope className="text-2xl mr-2" />
            <p><strong>Date of Joining:</strong> {formatDate(userInfo.doj)}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaPhone className="text-2xl mr-2" />
            <p><strong>Office Phone:</strong> {userInfo.officePhone}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaMobileAlt className="text-2xl mr-2" />
            <p><strong>Mobile:</strong> {userInfo.mobile}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaCheckCircle className="text-2xl mr-2" />
            <p><strong>Status:</strong> {userInfo.status}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaBuilding className="text-2xl mr-2" />
            <p><strong>Reporting Officer:</strong> {userInfo.rptOfficer}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaAppStore className="text-2xl mr-2" />
            <p><strong>Designation:</strong> {userInfo.designation}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaNetworkWired className="text-2xl mr-2" />
            <p><strong>Department:</strong> {userInfo.department}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaCity className="text-2xl mr-2" />
            <p><strong>Office:</strong> {userInfo.office}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaCity className="text-2xl mr-2" />
            <p><strong>City:</strong> {userInfo.city}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaEnvelope className="text-2xl mr-2" />
            <p><strong>Email:</strong> {userInfo.email}</p>
          </div>
          <div className="w-1/2 mb-4 flex items-center">
            <FaCheckCircle className="text-2xl mr-2" />
            <p><strong>Active:</strong> {userInfo.isActive ? 'Yes' : 'No'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
